import React from 'react';
//components
import ProductSegmentTag from 'pages/Quotes/components/Tags/ProductSegmentTag';
import MedicineTypeTag from 'pages/Quotes/components/Tags/MedicineTypeTag';
import { RefrigeratedTag } from '../components/Tags/RefrigeratedTag';
import StatusCircleOptions from 'components/StatusCircleOptions';
import { Visibility } from 'components/Visibility';
import { Column, Row } from 'components/Layout/Grid';
//interfaces
import { ITableModel } from 'components/Table/interface';
//styles
import { colors } from 'pages/Quotes/styles/colors';
import Text from 'components/Text';

const productCode = {
  label: 'Cód Produto',
  key: 'code',
};

const description = {
  label: 'Descrição',
  key: 'description',
};

const unit = {
  label: 'Unidade',
  key: 'unit',
};

const producer = {
  label: 'Fabricante',
  key: 'manufacturer',
};

const conversionFactor = {
  label: 'Conversão', key: 'conversionFactor'
};

const isCustomerComponent = (data: any) => {
  return (
    <Row className="justify-center w-100">
      <StatusCircleOptions
        color={data.isCustomer ? colors.cyanLightViveo : colors.greenDarkViveo} />
    </Row>
  );
};

const tagsComponent = (data: any) => {
  return (
    <Row className='tagsComponents'>
      <Visibility visible={data.suggested}>
        <div>
          <Visibility visible={data.productSegmentDescription}>
            <ProductSegmentTag tagText={data.productSegmentDescription} />
          </Visibility>
          <Visibility visible={data.medicineTypeDescription}>
            <MedicineTypeTag tagText={data.medicineTypeDescription} />
          </Visibility>
        </div>

        <RefrigeratedTag refrigerated={data?.refrigeration === "SIM"} />
      </Visibility>
    </Row>
  );
};

export const modelQuoteSolicitation: Array<ITableModel> = [
  {
    label: '',
    key: 'isCustomer',
    size: 40,
    maxSize: 40,
    Component: (data) => (isCustomerComponent(data)),
  },
  { label: 'Item', key: 'sequenceNumber', maxSize: 80 },
  { ...productCode, maxSize: 120 },
  {
    ...description,
    size: 330,
    Component: (item) => (
      <Column className='d-grid'>
        <Text
          showTip
          size={12}
          showTipContent={item?.description}
          className='text-styles color-blue-gray'
        >
          {item?.description}
        </Text>
        <Visibility visible={item?.substance}>
          <Text
            showTip
            size={12}
            color={colors.gray1}
            showTipContent={item?.substance}
          >
            {item?.substance}
          </Text>
        </Visibility>
      </Column>
    )
  },
  {
    label: '', key: '',
    size: 150,
    Component: (data: any) => (tagsComponent(data)),
  },
  unit,
  { label: 'Qtd', key: 'quantity' },
  conversionFactor,
  producer,
];

export const modelPrioritizedItemsTable: Array<ITableModel> = [
  { label: '', key: 'icon' },
  { label: 'Ordem', key: 'sequenceNumber' },
  { label: 'Cód Produto', key: 'supplierProductcode' },
  description,
  { label: '', key: 'medicineType' },
  { label: 'Subunid.', key: 'subUnit' },
  unit,
  conversionFactor,
  { label: 'Fabricante', key: 'manufacturer' },
  { label: 'Valor Subunid', key: 'subunidValue' },
  { label: 'Ações', key: 'actionsIcons' },
];
